import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = {
  filter: "name",
  sort: "name"
}
const _hoisted_4 = {
  filter: "productionPhase.text",
  sort: "productionPhase.text"
}
const _hoisted_5 = {
  filter: "productionGroup",
  sort: "productionGroup"
}
const _hoisted_6 = {
  filter: "productionGroup",
  sort: "productionGroup"
}
const _hoisted_7 = {
  filter: "productionGroup",
  sort: "productionGroup"
}
const _hoisted_8 = {
  filter: "emissionFactor",
  filterType: "number",
  sort: "emissionFactor"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { colspan: "10" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Production process configuration",
        text: "Production process configuration",
        class: "mb-0"
      }),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editConfiguration(null)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Add Configuration",
              text: "Add Configuration"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.items
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_3, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Name",
                      text: "Name"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Production Phase",
                      text: "Production Phase"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Production Group",
                      text: "Production Group"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "is Unique",
                      text: "is Unique"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Unique key",
                      text: "Unique key"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Emission Factor",
                      text: "Emission Factor"
                    })
                  ]),
                  _hoisted_9
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _createElementVNode("td", _hoisted_11, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.ProductionProcessConfigurationVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.productionPhase.text), 1),
                    _createElementVNode("td", null, [
                      (item.productionGroup)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.productionGroup), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                    ]),
                    _createElementVNode("td", null, [
                      (item.isUnique)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.isUnique), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.uniqueKey), 1),
                    _createElementVNode("td", null, _toDisplayString(item.emissionFactor), 1),
                    _createElementVNode("td", null, [
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.editConfiguration(item))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Edit",
                              text: "Edit"
                            })
                          ], 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}